module.exports = __webpack_public_path__ + "img/img_activation_email_1.bb02ba6d.png";